export const environment = {
  auth: {
    issuer: 'https://dev.authn.ebmpapst.net/realms/ebm-papst',
    clientId: 'customer-identity-admin',
  },
  api: {
    baseUrl: 'https://dev.authn.ebmpapst.net/admin/realms/ebm-papst',
    lambdaBaseUrl: 'https://ia.dev.authn.ebmpapst.net/api',
  },
  realmResource: 'realm-management',
  name: 'dev',
  denyAccessScope: 'access-gate-enabled',
};
